package com.vamvisions.main.components

import androidx.compose.runtime.Composable
import com.vamvisions.main.i18n.LocalStrings
import com.vamvisions.main.theme.AppStyleSheet
import org.jetbrains.compose.web.attributes.ButtonType
import org.jetbrains.compose.web.attributes.type
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

/** A loading message that assistive technology announces politely. */
@Composable
fun LoadingView() {
    Div(attrs = {
        classes(AppStyleSheet.statusMessage)
        attr("role", "status")
    }) {
        Text(LocalStrings.current.loading)
    }
}

/** A failure [message], announced at once, with a Retry button. */
@Composable
fun ErrorView(message: String, onRetry: () -> Unit) {
    Div(attrs = {
        classes(AppStyleSheet.statusMessage)
        attr("role", "alert")
    }) {
        P { Text(message) }
        Button(attrs = {
            type(ButtonType.Button)
            classes(AppStyleSheet.button)
            onClick { onRetry() }
        }) {
            Text(LocalStrings.current.retry)
        }
    }
}
